<template>
  <div class="homepage-header_content">
    <div class="hide_on_mobile">
      <PcSwiper :company-id="companyId" :img-list="imgList" />
    </div>
    <div class="hide_on_pc">
      <MobileSwiper :company-id="companyId" :img-list="imgList" />
    </div>
  </div>
</template>

<script>
import PcSwiper from './pcSwiper'
import MobileSwiper from './mobileSwiper'
export default {
  components: {
    PcSwiper,
    MobileSwiper
  },
  props: {
    companyId: {
      type: [String, Number],
      default: ''
    },
    imgList: {
      type: Array,
      default: () => [
        {
          url: '',
          targetId: ''
        }
      ]
    },
    height: {
      type: Number,
      default: 450
    }
  },
  data() {
    return {
      showPC: false
    }
  },

  mounted() {},

  created() {}
}
</script>

<style lang="scss">
.homepage-header_content {
  .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n + 1) {
    background-color: #d3dce6;
  }

  .el-carousel__arrow {
    border-radius: 0%;
    font-size: 40px;
    opacity: 0.8;
    height: 100px;
    width: 60px;
  }
  .el-carousel__arrow:hover {
    font-size: 40px;
    opacity: 1;
  }
  .el-carousel__arrow--right {
    right: 0px;
  }

  .el-carousel__arrow--left {
    left: 0px;
  }
}
</style>
